import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';

/**
 * Feedback de éxito no intrusivo (quick win de UX): un toast que se anuncia a
 * lectores de pantalla (`aria-live`) y se desvanece solo. `useToast()` expone
 * `mostrar(mensaje)` para confirmar acciones (p. ej. "Tarifa actualizada").
 */
interface ToastCtx {
  mostrar: (mensaje: string) => void;
}

const Ctx = createContext<ToastCtx | null>(null);

export function ProveedorToast({ children }: { children: ReactNode }) {
  const [mensaje, setMensaje] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const mostrar = useCallback((m: string) => {
    setMensaje(m);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setMensaje(null), 2600);
  }, []);

  return (
    <Ctx.Provider value={{ mostrar }}>
      {children}
      <div className="toast-zona" aria-live="polite" role="status">
        {mensaje && <div className="toast">✓ {mensaje}</div>}
      </div>
    </Ctx.Provider>
  );
}

export function useToast(): ToastCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useToast fuera del proveedor');
  return ctx;
}
